export const API_BASE_URL = process.env.EXPO_PUBLIC_API_URL || 'http://localhost:8000/api/v1';
export const NEON_AUTH_URL = process.env.EXPO_PUBLIC_NEON_AUTH_URL || 'https://ep-proud-bonus-a1hhzhl9-pooler.ap-southeast-1.aws.neon.tech/neondb/auth';

export const QUERY_KEYS = {
  userMe: 'userMe',
  dependents: 'dependents',
  guardians: 'guardians',
  timetable: 'timetable',
  progression: 'progression',
  belts: 'belts',
  memberships: 'memberships',
  paymentHistory: 'paymentHistory',
  plans: 'plans',
  pickupPersons: 'pickupPersons',
} as const;
